
/* ============================== src/components/Gantt/GanttDependencyArrows.jsx ============================== */
// src/components/Gantt/GanttDependencyArrows.jsx
// Чистый презентер. Ничего не измеряет, не знает о DOM, не держит состояния.
// Геометрия SVG (left, width, height) приходит через CSS-переменные
// --corner-width / --gantt-days-width / --arrows-height, которые
// устанавливает родитель (Gantt) на .gantt - они наследуются вниз
// по дереву до .gantt-arrows.
//
// Из пропсов осталась только проверка «есть ли что рендерить» (height):
// если .gantt-body ещё не измерен, стрелки рисовать не над чем.
import { memo } from "react";
import { computeArrowPaths } from "./dependencyArrows";

function GanttDependencyArrowsImpl({ rows, indexById, DW, yById, height }) {
  if (!yById || height === 0) return null;

  const paths = computeArrowPaths(rows, indexById, DW, yById);
  if (paths.length === 0) return null;

  return (
    <svg className="gantt-arrows" aria-hidden="true">
      <defs>
        <marker
          id="gantt-arrow-head"
          viewBox="0 0 8 8"
          refX="8"
          refY="4"
          markerWidth="7"
          markerHeight="7"
          orient="auto"
        >
          <path d="M0 0 L8 4 L0 8 z" className="gantt-arrow-head" />
        </marker>
        <marker
          id="gantt-arrow-head-overdue"
          viewBox="0 0 8 8"
          refX="8"
          refY="4"
          markerWidth="7"
          markerHeight="7"
          orient="auto"
        >
          <path d="M0 0 L8 4 L0 8 z" className="gantt-arrow-head-overdue" />
        </marker>
      </defs>
      {paths.map((p) => (
        <path
          key={p.id}
          d={p.d}
          className={`gantt-arrow${p.overdue ? " gantt-arrow--overdue" : ""}`}
          markerEnd={
            p.overdue
              ? "url(#gantt-arrow-head-overdue)"
              : "url(#gantt-arrow-head)"
          }
        />
      ))}
    </svg>
  );
}

export const GanttDependencyArrows = memo(GanttDependencyArrowsImpl);
export default GanttDependencyArrows;
